export default __webpack_public_path__ + "static/media/spaghetti.3293cdf0.jpg";